export type ReporterCustomerFields = {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  name: string;
};

export function splitFullName(fullName: string): { firstName: string; lastName: string } {
  const trimmed = fullName.trim();
  if (!trimmed) return { firstName: "", lastName: "" };
  const spaceIndex = trimmed.indexOf(" ");
  if (spaceIndex === -1) return { firstName: trimmed, lastName: "" };
  return {
    firstName: trimmed.slice(0, spaceIndex),
    lastName: trimmed.slice(spaceIndex + 1).trim(),
  };
}

export function joinFullName(firstName: string, lastName: string): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}

export function reporterFieldsFromCustomer(customer: ReporterCustomerFields): {
  firstName: string;
  lastName: string;
  email: string;
} {
  const firstName = customer.firstName?.trim() ?? "";
  const lastName = customer.lastName?.trim() ?? "";
  if (firstName || lastName) {
    return { firstName, lastName, email: customer.email ?? "" };
  }
  const fromName = splitFullName(customer.name);
  return { firstName: fromName.firstName, lastName: fromName.lastName, email: customer.email ?? "" };
}

export function reporterFieldsFromContact(contact: { name: string; email: string }): {
  firstName: string;
  lastName: string;
  email: string;
} {
  const split = splitFullName(contact.name);
  return { firstName: split.firstName, lastName: split.lastName, email: contact.email.trim().toLowerCase() };
}
